module.exports = __webpack_public_path__ + "static/media/bytt-no-18.7f7b1f84.mp3";